import React, { useState, useContext } from 'react';
import { Button, Form } from 'react-bootstrap';
// import githubContext from '../../context/github/githubContext';
// import githubContext from '../../context/github/githubContext';
// import GithubContext from '../../context/github/githubContext';
import githubContext from '../../context/github/githubContext';
import alertContext from '../../context/alert/AlertContext';

const Search = () => {
  const GithubContext = useContext(githubContext);
  const AlertContext = useContext(alertContext);

  const [text, setText] = useState('');

  const onChange = (e) => {
    setText(e.target.value);
    //console.log('val', this.state.text);
  };

  const onClick = (e) => {
    e.preventDefault();
    //console.log('aaioo');
    //console.log(this.state.text);
    if (text === '') {
      AlertContext.setAlert('Please enter something in searchbar', 'light');
    } else {
      GithubContext.searchUsers(text);
      setText('');
    }
  };
  return (
    <>
      <Form.Group className='mb-3' controlId='formBasicPassword'>
        <Form.Label style={{ color: 'green' }}>
          Search Any Github User
        </Form.Label>
        <Form.Control
          type='text'
          name='text'
          placeholder='Search...'
          onChange={onChange}
          value={text}
        />
      </Form.Group>
      <Button onClick={onClick}> Search</Button>
      {GithubContext.users.length > 0 && (
        <Button onClick={GithubContext.clearUser}>Clear</Button>
      )}
    </>
  );
};

export default Search;
